import { HoldingFormValues } from "./types";

export const FORM_ID = "holding-buy";

/** A fresh date is required whenever the panel opens or resets. */
export const createDefaultHolding = (): HoldingFormValues => ({
  instrument: null,
  quantity: "",
  amountEur: "",
  feeEur: "",
  cashbackEur: "",
  cashbackSource: null,
  date: new Date(),
  note: "",
});

/**
 * Field copy shared by the desktop panel and its mobile form. Both render the
 * same buy form, so the two must not drift apart.
 */
export const QUANTITY_HELPER = "Units bought, up to 6 decimal places.";
export const AMOUNT_HELPER =
  "What left the broker's cash for the units themselves.";
export const FEE_HELPER =
  "Optional — the broker's commission, charged on top of the amount above.";
